import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import './paquete-detalle-transporte.css';
import { withTranslation } from 'react-i18next';

import CityName from '../../../../commons/iataRenderService';

const Transporte = (props) => {
  const { t } = props;
  const iconsT = ['fa fa-plane', 'fa fa-bus', 'fa fa-ship', 'fa fa-train'];

  const getDate = (value, format, returnedText = '- -', appendedText = '') => {
    if (
      value === null
      || value === '0001-01-01T00:00:00'
      || value === undefined
    ) {
      return returnedText;
    }

    if (format.toUpperCase().includes('H') && value.includes('00:00:00')) {
      return returnedText;
    }

    return `${moment(value).format(format)} ${appendedText}`;
  };

  return (
    <Fragment>

      {props.transporte.tramos && props.transporte.tramos.map((trip) => (
        <>
          <div className='box-seg font-light text-sm bg-gray-200'>
            <div className='pr-4'>
              {`${t('layout:packages.details.traveling_with')}: `}
              <b>{trip.company}</b>

              {trip.travelCode !== '-' && ` - ${trip.travelCode}`}
            </div>

          </div>
          <div className='box-seg'>

            <div className=' flex flex-grow full-w py-5 '>

              <i className={`${iconsT[trip.transportTypeId - 1]} text-xl `} aria-hidden='true' />
              
            </div>

            { trip.originCode || trip.destinationCode == null
              ? null
              : (
                <div className='simplification'>
                  <CityName code={trip.originCode} />
                  {' '}
                  (
                  {trip.originCode}
                  )
                  -
                  <CityName code={trip.destinationCode} />
                  {' '}
                  (
                  {trip.destinationCode}
                  )

                </div>
              )}
            <div className='item-content in-left'>
              <span className='container-icon bg-mbr-color-primario '>
                <i className='fas fa-arrow-right ' />
              </span>
              <span>
                <span className='uppercase px-2'>{getDate(trip.departureDate, 'ddd D')}</span>
                      &nbsp;
                <span className='uppercase '>{getDate(trip.departureDate, 'MMM YYYY')}</span>
              </span>
              <i className='fas fa-chevron-right' style={{ padding: '0 9px' }} />
            </div>

            <div className='item-content middle'>
              <span className='internal-items'>
                <span>
                  {getDate(trip.departureDate, 'HH:mm')}
                  {' '}
                  hs
                  {' '}
                  <span className='font-extrabold px-2'>{trip.originCode}</span>
                </span>
                {' '}
                -
                <span>
                  <span className='font-extrabold px-2'>
                    {' '}
                    {trip.destinationCode}
                  </span>
                  {getDate(trip.arrivalDate, 'HH:mm')}
                  {' '}
                  hs
                  {' '}

                </span>
              </span>

            </div>

            <div className='item-content in-left'>
              <i className='fas fa-chevron-right' style={{ padding: '0 9px' }} />
              <span className='container-icon bg-mbr-color-primario'>
                <i className='fas fa-arrow-left ' />
              </span>
              <span>
                <span className='uppercase  px-2'>{getDate(trip.arrivalDate, 'ddd D')}</span>
                      &nbsp;
                <span className='uppercase'>{getDate(trip.arrivalDate, 'MMM YYYY')}</span>
              </span>

            </div>

          </div>

          {/* <div className=''>{trip.travelCode !== '-' && trip.travelCode}</div>
          <div className=''>{trip.company !== '-' && trip.company}</div> */}

        </>
      ))}

    </Fragment>
  );
};
export default withTranslation()(Transporte);
